import { FormError, Select, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ProjectSearch } from "@/components/projects";
import { useProtocolFormContext } from "./context";

export function ProtocolFormSubject() {
	/** Context */
	const { t } = useTranslation();
	const methods = useFormContext<ProtocolFormSchema>();
	const type = useWatch({ control: methods.control, name: "subject.type" });
	const { hasType } = useProtocolFormContext();

	/** Guard */
	if (!hasType) return null;

	/** Render */
	return (
		<React.Fragment>
			<div className="v-stack">
				<p className="label">Context</p>
				<div className="grid grid-cols-[200px_1fr] gap-x-4">
					<Select
						label={undefined}
						isRequired={false}
						control={methods.control}
						name="subject.type"
						onChange={() => {
							methods.setValue("subject.value", null as any);
						}}
						options={[
							{ label: t("projects.project"), value: "project", item: { label: "Project" } },
							{ label: t("general.other"), value: "other", item: { label: "Other" } },
						]}
						renderOption={(_, label) => <p>{label}</p>}
						itemNotFoundLabel="No options found"
						isNullable={false}
						data-cy="protocol-subject-type-select"
					/>
					{type === "project" && (
						<div>
							<ProjectSearch
								label={null}
								onChange={(project) => {
									if (!project) return;
									methods.setValue("subject.value", project);
								}}
								defaultProjectId={methods.getValues("subject.value")}
							/>
							<FormError
								errors={methods.formState.errors}
								name="subject.value"
							/>
						</div>
					)}
					{type === "other" && (
						<TextInput
							control={methods.control}
							name="subject.value"
							label={undefined}
							placeholder={t("protocols.short_description")}
							isRequired={false}
							data-cy="protocol-subject-value-input"
						/>
					)}
				</div>
			</div>
		</React.Fragment>
	);
}
